import { validDDDs } from 'utils/basicUtils';
import Yup from 'utils/validation';

export const states = [
  '',
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
];

export const daysOfWeek = [
  'Domingo',
  'Segunda-Feira',
  'Terça-Feira',
  'Quarta-Feira',
  'Quinta-Feira',
  'Sexta-Feira',
  'Sábado',
];

export const getValidationSchema = (formName: string) => {
  switch (formName) {
    case 'Editar Evento':
    case 'Novo Evento':
      return Yup.object().shape({
        title: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('not-empty', 'Nome do evento é obrigatório', function (value) {
            if (!value) return true;
            return value.trim().length > 0;
          }),
        category: Yup.array(),
        description: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value)),
        startDate: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-date', 'Data de início inválida (use o formato DD/MM/AAAA)', function (value) {
            if (!value) return true;
            if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return false;
            const [day, month, year] = value.split('/').map(Number);
            const date = new Date(year, month - 1, day);
            return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
          })
          .test('is-not-equal', 'Data de início não pode conter todos os números iguais', function (value) {
            if (!value) return true;
            return !/^(.)\1+$/.test(value.replace(/[-/]/g, ''));
          }),
        endDate: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-date', 'Data de término inválida (use o formato DD/MM/AAAA)', function (value) {
            if (!value) return true;
            if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value)) return false;
            const [day, month, year] = value.split('/').map(Number);
            const date = new Date(year, month - 1, day);
            return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day;
          })
          .test('is-not-equal', 'Data de término não pode conter todos os números iguais', function (value) {
            if (!value) return true;
            return !/^(.)\1+$/.test(value.replace(/[-/]/g, ''));
          })
          .test('is-after-start', 'Data de término deve ser igual ou posterior à data de início', function (value) {
            const { startDate } = this.parent;
            if (!value || !startDate) return true;
            if (!/^\d{2}\/\d{2}\/\d{4}$/.test(value) || !/^\d{2}\/\d{2}\/\d{4}$/.test(startDate)) return true;
            const [sDay, sMonth, sYear] = startDate.split('/').map(Number);
            const [eDay, eMonth, eYear] = value.split('/').map(Number);
            const start = new Date(sYear, sMonth - 1, sDay);
            const end = new Date(eYear, eMonth - 1, eDay);
            return end >= start;
          }),
        startTime: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-time', 'Hora de início inválida (use o formato HH:MM)', function (value) {
            if (!value) return true;
            if (!/^\d{2}:\d{2}$/.test(value)) return false;
            const [h, m] = value.split(':').map(Number);
            return h >= 0 && h < 24 && m >= 0 && m < 60;
          }),
        endTime: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-time', 'Hora de fim inválida (use o formato HH:MM)', function (value) {
            if (!value) return true;
            if (!/^\d{2}:\d{2}$/.test(value)) return false;
            const [h, m] = value.split(':').map(Number);
            return h >= 0 && h < 24 && m >= 0 && m < 60;
          }),
        email: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .email('E-mail inválido (exemplo: nome@dominio.com)')
          .matches(/^(?!\d+$).*/, 'O campo e-mail não pode conter apenas números'),
        address: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .matches(/^(?!\d+$).*/, 'O campo endereço não pode ser apenas números'),
        placeId: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value)),
        place: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value)),
        phone: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-ddd', 'DDD do telefone inválido', function (value) {
            if (!value) return true;
            const ddd = value.match(/^\((\d{2})\)/);
            if (!ddd) return false;
            return validDDDs.includes(ddd[1]);
          })
          .test('is-valid-length', 'Telefone deve conter 10 ou 11 dígitos', function (value) {
            if (!value) return true;
            const digits = value.replace(/\D/g, '');
            return digits.length >= 10 && digits.length <= 11;
          })
          .test('not-all-same', 'Telefone não pode ter todos os números iguais', function (value) {
            if (!value) return true;
            const digits = value.replace(/\D/g, '');
            return !/^(\d)\1+$/.test(digits);
          }),
        whatsapp: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-ddd', 'DDD do Whatsapp inválido', function (value) {
            if (!value) return true;
            const ddd = value.match(/^\((\d{2})\)/);
            if (!ddd) return false;
            return validDDDs.includes(ddd[1]);
          })
          .test('is-valid-length', 'Whatsapp deve conter 10 ou 11 dígitos', function (value) {
            if (!value) return true;
            const digits = value.replace(/\D/g, '');
            return digits.length >= 10 && digits.length <= 11;
          })
          .test('not-all-same', 'Whatsapp não pode ter todos os números iguais', function (value) {
            if (!value) return true;
            const digits = value.replace(/\D/g, '');
            return !/^(\d)\1+$/.test(digits);
          }),
        price: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value)),
        addressInfo: Yup.object().shape({
          zipCode: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value))
            .test('is-valid-cep', 'CEP inválido (formato 00000-000)', function (value) {
              if (!value) return true;
              const digits = value.replace(/\D/g, '');
              if (digits.length !== 8) return false;
              return !/^(.)\1+$/.test(digits);
            }),
          neighborhood: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value))
            .matches(/^(?!^\d+$)[\d\D]*$/, 'O bairro não pode conter somente números'),
          number: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value)),
          city: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value)),
          state: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value)),
        }),
        site: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-url', 'Link do site inválido', function (value) {
            if (!value) return true;
            const urlPattern =
              /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
            return urlPattern.test(value);
          }),
        youtubeLink: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-url', 'Link do Youtube inválido', function (value) {
            if (!value) return true;
            const urlPattern =
              /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
            return urlPattern.test(value);
          }),
        instagramLink: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-url', 'Link do Instagram inválido', function (value) {
            if (!value) return true;
            const urlPattern =
              /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
            return urlPattern.test(value);
          }),
        facebookLink: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-url', 'Link do Facebook inválido', function (value) {
            if (!value) return true;
            const urlPattern =
              /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
            return urlPattern.test(value);
          }),
        banners: Yup.array(),
        image: Yup.array(),
        link: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-url', 'Link do evento inválido', function (value) {
            if (!value) return true;
            const urlPattern =
              /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
            return urlPattern.test(value);
          }),
      });

    case 'Editar Roteiro':
    case 'Novo Roteiro':
      return Yup.object().shape({
        title: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value)),
        category: Yup.array(),
        description: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value)),
        address: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value)),
        placeId: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value)),
        addressInfo: Yup.object().shape({
          zipCode: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value))
            .test('is-valid-cep', 'CEP deve ter o formato XXXXX-XXX', function (value) {
              if (!value) return true;
              const cleanedValue = value.replace(/\D/g, '');
              if (cleanedValue.length === 0) return true;
              if (cleanedValue.length !== 8) return false;
              return !/^(.)\1+$/.test(cleanedValue);
            }),
          neighborhood: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value))
            .test('not-only-numbers', 'O bairro não pode conter somente números', function (value) {
              if (!value) return true;
              return !/^\d+$/.test(value);
            }),
          number: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value)),
          additionalData: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value)),
          street: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value)),
          city: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value)),
          state: Yup.string()
            .nullable()
            .transform(value => (value === null ? '' : value)),
        }),
        images: Yup.array(),
        banners: Yup.array(),
        activities: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value)),
        mainItinerary: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value)),
        site: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-url', 'Link do site inválido', function (value) {
            if (!value) return true;
            const urlPattern =
              /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
            return urlPattern.test(value);
          }),
        youtubeLink: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-url', 'Link do Youtube inválido', function (value) {
            if (!value) return true;
            const urlPattern =
              /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
            return urlPattern.test(value);
          }),
        instagramLink: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-url', 'Link do Instagram inválido', function (value) {
            if (!value) return true;
            const urlPattern =
              /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
            return urlPattern.test(value);
          }),
        facebookLink: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-url', 'Link do Facebook inválido', function (value) {
            if (!value) return true;
            const urlPattern =
              /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
            return urlPattern.test(value);
          }),
        whatsapp: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value)),
        link: Yup.string()
          .nullable()
          .transform(value => (value === null ? '' : value))
          .test('is-valid-url', 'Link inválido', function (value) {
            if (!value) return true;
            const urlPattern =
              /^(https?:\/\/)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)$/;
            return urlPattern.test(value);
          }),
      });
    default:
      return Yup.object().shape({});
  }
};
